import { TextField, FormControl, Backdrop, Box, Button, CircularProgress, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Checkbox, FormControlLabel, Grid } from "@mui/material"
import Popup from "../../../Base/views/Popup"
import { useEffect, useState } from "react";
import { GetAtsInvoiceCalculationHelper } from "../../helper/AtsInvoiceHelper";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import SendIcon from '@mui/icons-material/Send';
import AtsInvoicePdf from "./AtsInvoicePdf";
import { pdf } from "@react-pdf/renderer";
import { CSVLink } from "react-csv";
import AtsInvoiceMail from "./AtsInvoiceMail";
import { useDispatch, useSelector } from "react-redux";
import { AddAtsInvoiceAction } from "../../../../../store/ATS/Invoice/Action";
import { useTransition } from "react";

const ATSGenerateInvoicePopup = ({ setShowGenerateInvoice, selectedCandidates, currentData, filters, companylogo, letterHeadData, reset }) => {
    const [finalData, setFinalData] = useState([]);
    const [candidateAmount, setCandidateAmount] = useState([]);
    const initialValue = {
        po_no: "",
        po_no_flag: false,
    };
    const [form, setForm] = useState(initialValue);
    const [openPopup, setOpenPopup] = useState(false);
    const [sendmail, setSendMail] = useState(false);
    const [show, setShow] = useState(true);
    const [, startTransition] = useTransition();
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const today = year + '-' + month + '-' + day;
    const dispatch = useDispatch()
    const { company_config_data } = useSelector((state) => state?.AncillaryReducer?.CompanyConfigReducer);
    useEffect(() => {
        getCalculation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getCalculation = () => {
        let filteredData = []
        selectedCandidates?.forEach(res => {
            filteredData.push({ candidate_id: res?.candidate_id, commission_percentage: +res?.commission_percentage, billable_ctc: +res?.billable_ctc })
        })
        GetAtsInvoiceCalculationHelper({
            ats_company_id: currentData?.ats_company_id || currentData?.ats_grouporg_id,
            candidate_data: JSON.stringify(filteredData)
        }).then(res => {
            setShow(false)
            if (res?.data?.statuscode === 200) {
                setFinalData(res?.data?.data);
                startTransition(() => {
                    let temp = []
                    selectedCandidates?.forEach(result => {
                        var data = res?.data?.data?.find(item => +item.candidate_id === +result.candidate_id)
                        temp.push({ ...result, amount: data?.amount })
                    })
                    setCandidateAmount(temp)
                });
            }
        })

    }

    const getAmount = (id) => {
        let data = finalData?.filter(res => +res.candidate_id === +id)
        return data?.[0]?.amount
    }

    const [pdfLoading, setPdfLoading] = useState(false);
    const handleDownloadPDF = async () => {
        setPdfLoading(true);
        const MyDocument = (
            <AtsInvoicePdf
                performadata={currentData}
                performaCandidateData={selectedCandidates}
                amountData={finalData}
                getAmount={getAmount}
                today={today}
                companylogo={companylogo}
                letterHeadData={letterHeadData}
                orgConfigData={company_config_data}
            />
        );

        const blob = await pdf(MyDocument).toBlob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `Proforma.pdf`;
        a.click();
        // Clean up the URL object
        URL.revokeObjectURL(url);
        setPdfLoading(false);
    };

    const headers = [
        { label: "Candidate Name", key: "candidate_name" },
        { label: "Job Title", key: "job_title" },
        { label: "Job Location", key: "job_location" },
        { label: "Joined Date", key: "joined_date" },
        { label: "Billable CTC", key: "billable_ctc" },
        { label: "Billable Amount", key: "amount" },
    ];
    const handleSendMail = () => {
        setSendMail(true)
    }
    const handleSave = () => {
        if (form?.po_no_flag) {
            setOpenPopup(true);
        }
        else {
            handleSubmit();
        }

    }
    const handleSubmit = () => {
        setOpenPopup(false);
        let job_id = []
        candidateAmount?.forEach(res => {
            job_id.push(res?.candidate_job_id)
        })
        const gstJson ={
            candidate_total: finalData?.[0]?.candidate_total,
            cgst: finalData?.[0]?.cgst,
            sgst: finalData?.[0]?.sgst,
            igst: finalData?.[0]?.igst,
            cgst_total: finalData?.[0]?.cgst_total,
            sgst_total: finalData?.[0]?.sgst_total,
            igst_total: finalData?.[0]?.igst_total,
            gst_applicable: finalData?.[0]?.gst_applicable
        }
        dispatch(AddAtsInvoiceAction({
            invoice_date: today,
            invoice_amount: +finalData?.[0]?.invoice_amt,
            gst_total: +finalData?.[0]?.gst_total,
            company_id: currentData?.ats_company_id || currentData?.ats_grouporg_id,
            candidates_json: JSON.stringify(candidateAmount),
            candidate_job_ids: `{${job_id}}`,
            po_no: form?.po_no,
            gst_json: JSON.stringify(gstJson),
            tds_amount: finalData?.[0]?.tds_total,
            received_amount: "0"
        },(error, result) => {
            if (!error && result?.data?.statuscode === 200) {
                setShowGenerateInvoice(false);
                reset(job_id);
            }
          }))
    }
    const handleInputChange = (event, value) => {
        if (["po_no_flag"].includes(event?.target?.name)) {
            setForm({
                ...form,
                [event.target.name]: event.target.checked,
            });
        } else {
            setForm({
                ...form,
                [event.target.name]: event.target.value,
            });
        }
    };
    return (
        <>
            <Popup
                maxWidth="sm"
                fullWidth={true}
                title="Enter PO Number"
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <FormControl fullWidth>
                    <TextField
                        size="small"
                        value={form?.po_no}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                        id="po_no"
                        label="PO Number"
                        name="po_no"
                        autoComplete="po_no"

                    />
                </FormControl>
                <Box sx={{
                    width: "100%",
                    mt: 3,
                    display: "flex",
                    justifyContent: "space-between",
                }}>
                    <Button onClick={() => { setOpenPopup(false); }} size="small" variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        size="small" variant="outlined">
                        Save
                    </Button>
                </Box>
            </Popup>
            <Popup
                title={"Proforma"}
                openPopup={true}
                setOpenPopup={setShowGenerateInvoice}
                maxWidth={"md"}
                fullWidth={true}
            >
                {
                    show && <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                }
                <Grid container>
                    <Grid item xs={12} sm={8}>
                        <Box sx={{ display: 'flex', alignItems: 'start' }}>
                            <Typography sx={{ fontWeight: "bold", minWidth: '100px' }}>Bill To&nbsp;</Typography>
                            <Typography sx={{ ml: 1.5 }}>{currentData?.billing_name || "NA"}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'start' }}>
                            <Typography sx={{ fontWeight: "bold", minWidth: '100px' }}>Billing Address&nbsp;</Typography>
                            <Typography sx={{ ml: 1.5 }}>{currentData?.billing_address || "NA"}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'start' }}>
                            <Typography sx={{ fontWeight: "bold", minWidth: '100px' }}>GST No.&nbsp;</Typography>
                            <Typography sx={{ ml: 1.5 }}>{currentData?.gst || "NA"}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex', alignItems: 'start' }}>
                            <Typography sx={{ fontWeight: "bold", minWidth: '100px' }}>Proforma Date&nbsp;</Typography>
                            <Typography sx={{ ml: 1.5 }}>{ConvertDate(today) || "NA"}</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ display: "flex", justifyContent: "flex-end", m: 1 }}>
                    <Button className="mpl-primary-btn" onClick={handleDownloadPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={18} disableShrink color="inherit" /> : null}>
                        Download PDF
                    </Button>
                    <Button sx={{ ml: 2 }} className="mpl-primary-btn">
                        <CSVLink className="ats-csv-btn" data={candidateAmount} headers={headers} filename={"Proforma"}>
                            Download CSV
                        </CSVLink>
                    </Button>
                    <Button sx={{ ml: 2 }} className="mpl-primary-btn" onClick={handleSendMail}>
                        <SendIcon fontSize="small" sx={{ mr: 1 }} /> Send Mail
                    </Button>
                </Box>
                <Box>
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Candidate Name</TableCell>
                                    <TableCell>Job Title</TableCell>
                                    <TableCell>Job Location</TableCell>
                                    <TableCell>Joined Date</TableCell>
                                    <TableCell align="right">Joined CTC</TableCell>
                                    <TableCell align="right">Professional Fee %</TableCell>
                                    <TableCell align="right">Billable CTC</TableCell>
                                    <TableCell align="right">Billable Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {selectedCandidates?.map((row) => (
                                    <TableRow
                                        key={row?.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell>{row?.candidate_name}</TableCell>
                                        <TableCell>{row?.job_title}</TableCell>
                                        <TableCell>{row?.job_location}</TableCell>
                                        <TableCell>{row?.joined_date ? ConvertDate(row?.joined_date) : ""}</TableCell>
                                        <TableCell align="right">{formatAmount(row?.joined_ctc)}</TableCell>
                                        <TableCell align="right">{row?.commission_percentage}</TableCell>
                                        <TableCell align="right">{formatAmount(row?.billable_ctc)}</TableCell>
                                        <TableCell align="right">{formatAmount(getAmount(row?.candidate_id))}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Popup
                    title={"Proforma"}
                    openPopup={sendmail}
                    setOpenPopup={setSendMail}
                    maxWidth={"md"}
                    fullWidth={true}
                >
                    <AtsInvoiceMail
                        setSendMail={setSendMail}
                        setShowGenerateInvoice={setShowGenerateInvoice}
                        performadata={currentData}
                        performaCandidateData={selectedCandidates}
                        amountData={finalData}
                        getAmount={getAmount}
                        today={today}
                        companylogo={companylogo}
                        letterHeadData={letterHeadData}
                        orgConfigData={company_config_data}
                    />
                </Popup>
                <Box sx={{ mt: 2, justifyContent: "flex-end", display: "flex" }}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                            <Typography sx={{ minWidth: '120px' }}>Invoice Amount&nbsp;</Typography>
                            <Typography sx={{ mr: 1, textAlign: "right" }}>{finalData?.[0]?.candidate_total || 0}</Typography>
                        </Box>
                        {Number(finalData?.[0]?.tds_percentage) > 0 && (
                            // Show TDS if available
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Typography sx={{ minWidth: "120px" }}>TDS</Typography>
                                <Typography sx={{ mr: 1 , textAlign: "right"}}>{formatAmount(finalData?.[0]?.tds_total)}</Typography>
                            </Box>
                        )}
                        {finalData?.[0]?.gst_applicable && (
                        <>
                            {Number(finalData?.[0]?.igst) > 0 ? (
                                // Show IGST if available
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Typography sx={{ minWidth: "120px" }}>IGST&nbsp;-&nbsp;{finalData?.[0]?.igst || 0}%</Typography>
                                    <Typography sx={{ mr: 1 , textAlign: "right"}}>{finalData?.[0]?.igst_total || 0}</Typography>
                                </Box>
                            ) : (
                              <>
                                <Box sx={{ display: 'flex', alignItems: 'center',justifyContent: "space-between", }}>
                                    <Typography sx={{ minWidth: '120px' }}>CGST&nbsp;-&nbsp;{finalData?.[0]?.cgst || 0}%</Typography>
                                    <Typography sx={{ mr: 1, textAlign: "right" }}>{finalData?.[0]?.cgst_total || 0}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", }}>
                                    <Typography sx={{ minWidth: '120px' }}>SGST&nbsp;-&nbsp;{finalData?.[0]?.sgst || 0}%</Typography>
                                    <Typography sx={{ mr: 1, textAlign: "right" }}>{finalData?.[0]?.sgst_total || 0}</Typography>
                                 </Box>
                              </>
                            )}
                        </>
                        )}
                        <Divider sx={{ fontWeight: "bold" }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, justifyContent: "space-between", }}>
                            <Typography sx={{ fontWeight: "bold", minWidth: '120px' }}>Total Amount&nbsp;</Typography>
                            <Typography sx={{ mr: 1, textAlign: "right" }}>{formatAmount(finalData?.[0]?.invoice_amt || 0)}</Typography>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="po_no_flag"
                                checked={form?.po_no_flag || false}
                                onChange={handleInputChange}
                            />
                        }
                        label="Generate with PO Number"
                    />
                    <Button
                        className="mpl-primary-btn"
                        onClick={handleSave}
                        sx={{ mt: 2 }}
                    >
                        Generate Invoice
                    </Button>
                </Box>
            </Popup>
        </>
    )
}
const formatAmount = (value) => {
  const num = Number(value);
  return isNaN(num) ? "0.00" : num?.toFixed(2);
};
export default ATSGenerateInvoicePopup
